import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { ContentBox } from '../AppLayout/ContentBox';
import { pxToRem } from 'src/common/utils/fonts';

type TableLayoutProps = {
  fetching?: boolean;
  table: React.ReactNode;
};

export const TableLayoutWithoutScrollArea: React.FC<TableLayoutProps> = ({ fetching, table }) => {
  const { palette } = useTheme();

  return (
    <ContentBox>
      {fetching ? null : (
        <Box
          sx={{
            flex: '1',
            minHeight: pxToRem(44),
            backgroundColor: palette.grey['200'],
          }}
        >
          {table}
        </Box>
      )}
    </ContentBox>
  );
};
